function StatsSection() {
  const stats = [
    {
      icon: 'ri-percent-line',
      value: '92%',
      label: '平均稼働率',
      description: '年間を通じて高い稼働率を維持',
    },
    {
      icon: 'ri-star-fill',
      value: '4.9',
      label: 'レビュー評価',
      description: 'ゲストから高評価を獲得',
    },
    {
      icon: 'ri-home-smile-line',
      value: '150+',
      label: '対応件数',
      description: '累計サポート実績',
    },
    {
      icon: 'ri-calendar-check-line',
      value: '3年+',
      label: '運営実績',
      description: '東京での民泊運営経験',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/20 mb-6">
            <i className="ri-bar-chart-box-line text-emerald-600"></i>
            <span className="text-sm text-emerald-700 font-semibold whitespace-nowrap">数字で語る実績</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            確かな実績と信頼
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            理論だけではなく、実際の運営データに基づいた確かなサポートを提供しています
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 text-center group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-5xl font-bold text-slate-900 mb-3">
                {stat.value}
              </div>
              <div className="text-lg font-semibold text-slate-700 mb-2">
                {stat.label}
              </div>
              <p className="text-sm text-slate-500 leading-relaxed">
                {stat.description}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Testimonial 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100">
            <div className="flex items-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              「初めての民泊運営で不安でしたが、申請から運営まで丁寧にサポートしていただき、初月から高稼働率を達成できました。特に価格設定のアドバイスが的確で、想定以上の収益を得られています。」
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full">
                <span className="text-white font-bold text-lg">K.S</span>
              </div>
              <div>
                <div className="font-semibold text-slate-900">K.S様</div>
                <div className="text-sm text-slate-500">品川区・一棟貸しオーナー</div>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100">
            <div className="flex items-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              「自分で運営していた時は稼働率60%程度でしたが、サポートを受けてから90%以上に改善。ゲスト対応の負担も大幅に減り、本業に集中できるようになりました。プロに任せて本当に良かったです。」
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full">
                <span className="text-white font-bold text-lg">M.T</span>
              </div>
              <div>
                <div className="font-semibold text-slate-900">M.T様</div>
                <div className="text-sm text-slate-500">渋谷区・マンションオーナー</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StatsSection;